<!-- 로그인 폼 -->
<template>
    <div class="uk-flex uk-flex-column uk-height-1-1">
        <div class="uk-card uk-card-default uk-card-small uk-width-large uk-align-center uk-margin-auto-vertical">
            <div class="uk-card-header uk-text-center">
                <app-elem-logo class=""></app-elem-logo>
            </div>
            <div class="uk-card-body uk-text-center">
                <h2 class="uk-heading-medium uk-margin-large-bottom uk-text-primary">🔐 비밀번호 재설정이 완료되었습니다!!</h2>

                <!-- 카카오인경우 -->
                <button v-if="isKakao" class="uk-button uk-button-dark" @click="closeWithKakao">
                    <i class="material-icons">close</i>
                    닫기
                </button>

                <!-- 기타 브라우저 -->
                <button v-if="! isKakao" class="uk-button uk-button-white" @click="moveMain">
                    <i class="material-icons">home</i>
                    홈으로
                </button>
            </div>


        </div>


    </div>

</template>

<script>
export default {
    props: {


    },
    data: function () {
        return {
            isKakao: this.isKakaoInAppBrowser(),
        };
    },
    computed: {

    },
    methods: {
        isKakaoInAppBrowser() {
            const ua = navigator.userAgent.toLowerCase();
            return ua.includes('kakaotalk');
        },

        moveMain() {
            location.href = '/';
        },

        closeWithKakao() {
            location.href = 'kakaotalk://inappbrowser/close'; // 필요 시 닫기
        },
    },
}
</script>
